<template>
  <div style="display: flex; justify-content: center; align-items: center;padding-top:100px">
    <a-card class="trial-card">
      <div class="trial-content">
        <a-icon type="gift" theme="filled" class="success-icon" />
        <h1 class="title">Your account has been {{ subscribeStatus }}</h1>
        <p class="message">
          Please contact your IT Admin. Alternatively, you can re-subscribe on Azure
        </p>
        <a-button type="primary" size="large" @click="toAzure"
          class="action-button">
          Azure marketplace
        </a-button>
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subscribeStatus: 'unsubscribed'
    };
  },
  mounted() {
    if (this.$route.query.errMsg && typeof this.$route.query.errMsg === 'string') {
      this.subscribeStatus = this.$route.query.errMsg;
    }
  },
  methods: {
    toAzure() {
      window.location.href = 'https://portal.azure.com/'
    }
  }
};
</script>

<style scoped>
.trial-card {
  max-width: 600px;
  margin: 50px auto;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.trial-content {
  padding: 30px;
}

.success-icon {
  font-size: 48px;
  color: var(--main-color);
  margin-bottom: 20px;
}

.title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #333;
}

.message {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 30px;
}

.expiry-date {
  font-weight: bold;
  color: #1890ff;
}

.action-button {
  width: 200px;
  height: 40px;
  font-weight: 500;
}
</style>